export const getPreviewFromOrigin = (originImageUrl: string | undefined, previewProportions = '400x400') =>
    originImageUrl && originImageUrl?.endsWith('orig')
        ? originImageUrl.slice(0, -4).concat(previewProportions)
        : originImageUrl;
